import {createSlice, PayloadAction, SliceCaseReducers} from '@reduxjs/toolkit';
import {AppActions} from '../../actions';
import {LoginResponsePayload, SendCodeResponsePayload} from '../../../shared/models/api';
import {AuthorizeEsiaResponsePayload} from '../../../shared/models/api/authorizeEsiaResponsePayload';

export interface LoginState {
  loginResponse: LoginResponsePayload | null;
  login: string | null;
  sendCodeResponse: SendCodeResponsePayload | null;
  esiaLink: string | null;
  esiaCode: {
    code: string | null;
    state: string | null;
  };
  esiaUserNotAccept: boolean;
  esiaUserHasNoCards: boolean;
  esiaRegistrationInfo: AuthorizeEsiaResponsePayload | null;
}

const initialState: LoginState = {
  loginResponse: null,
  login: null,
  sendCodeResponse: null,
  esiaLink: null,
  esiaCode: {
    code: null,
    state: null,
  },
  esiaUserNotAccept: false,
  esiaUserHasNoCards: false,
  esiaRegistrationInfo: null,
};

export const loginSlice = createSlice<LoginState, SliceCaseReducers<LoginState>>({
  name: '@@eskso/login',
  initialState,
  reducers: {
    setLoginResponse: (state, action: PayloadAction<LoginResponsePayload>) => {
      state.loginResponse = action.payload;
    },
    setLogin: (state, action: PayloadAction<string>) => {
      state.login = action.payload;
    },
    setSendCodeResponse: (state, action: PayloadAction<SendCodeResponsePayload>) => {
      state.sendCodeResponse = action.payload;
    },
    setEsiaLink: (state, action: PayloadAction<string | null>) => {
      state.esiaLink = action.payload;
    },
    setEsiaCode: (state, {payload}: PayloadAction<LoginState['esiaCode']>) => {
      state.esiaCode = payload;
    },
    setEsiaUserNotAccept: (state, {payload}: PayloadAction<boolean>) => {
      state.esiaUserNotAccept = payload;
    },
    setEsiaUserHasNoCards: (state, {payload}: PayloadAction<boolean>) => {
      state.esiaUserHasNoCards = payload;
    },
    setEsiaRegistrationInfo: (state, {payload}: PayloadAction<AuthorizeEsiaResponsePayload>) => {
      state.esiaRegistrationInfo = payload;
    },
    resetEsiaFlow: (state, _action: PayloadAction<null>) => {
      state.esiaLink = null;
      state.esiaCode = {code: null, state: null};
      state.esiaUserNotAccept = false;
    },
    reset: () => {
      return initialState;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const login = loginSlice.reducer;
